<template lang="pug">
  div.modal
    div.modal-dialog
      div.modal-content
        div.modal-body.modal-error
          p.text-center {{ context }}
          div.modal-footer
            button.btn.btn-white(@click="notify") 回主畫面
            //- button.btn.btn-white(@click="reset") 重置藥櫃
</template>

<script>
export default {
  name: 'LockDevice',
  data() {
    return {
      context: '',
    };
  },
  destroyed() {
    this.$store.commit('SHOW_MODAL', { modalName: 'lockDevice', status: false });
  },
  mounted() {
    this.confirm();
  },
  methods: {
    reset() {
      this.$store.dispatch('resetCabinet');
      this.context = '系統重置中';
      setTimeout(() => {
        this.$emit('closeLockDeviceModal');
        this.$store.dispatch('openDevice');
      }, 2000);
    },
    confirm() {
      this.context = '偵測藥盒無法開啟，已紀錄';
      this.$store.state.instance.patch(`/api/device/${this.currentDevice.id}/`, {
        error: true,
      })
      .then(() => {
        // this.context = '已回報, 藥盒上鎖';
        this.$emit('errorReturned');
      });
    },
    notify() {
      this.$store.commit('SHOW_MODAL', { modalName: 'lockDevice', status: false });
      this.$router.push({ name: 'Main' });
    },
  },
  computed: {
    currentDevice() {
      return this.$store.getters.currentDevice;
    },
  },
};
</script>

<style lang="sass">
.modal
  display: flex
  justify-content: center;
  align-items: center;
  background: rgba(0,0,0,0.3);

.modal-dialog
  // margin-top: 300px !important
  width: 500px !important

.modal-error
  border-color: #FF3811
  background-color: #FF3811
  color: white

.modal-warning
  border-color: #ff960c
  background-color:#ff960c
  color: white

.modal-success
  border-color: #42b883
  background-color: #42b883
  color: white  

.modal-footer
  justify-content: center
  border: 0
  .btn
    border: 1px solid white

.modal-body
  p
    margin-bottom: 0

.message-modal
  z-index: 1080

.btn-white
  &:active
    background-color: white
    color: gray
</style>






// WEBPACK FOOTER //
// LockDevice.vue?68e03060